<template>
  <complex-select
    :tb-head="Head"
    :tb-data="Data"
    :key-str="keyword"
    v-model="value1"
    @select="onSelect"
    @clear="onClear"
    :empty="empty"
    :pageSize="pageParams.pageSize"
    :pageIndex="pageParams.pageIndex"
    :listTotal="total"
    :pageType="pageType"
    @currentPage="currentPage"
    @inputText="inputText"
    :disabled="disabled"
    @changeSelect="changeSelect"
    :select-list="selectList"
    :is-select="isSelect"
    :select-key="selectKey"
    :select-label="selectLabel"
    :clearable="clearable"
    :readonly="readonly"
    :isShowClear="isShowClear"
  />
</template>
<script>
import complexSelect from '@/components/common/complexSelect'
export default {
  components: {
    complexSelect
  },
  props: {
    selectKey: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: ''
    },
    selectList: {
      type: Array,
      default: () => []
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    isShowClear: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: true
    },
    pageType: {
      type: Boolean,
      default: false
    },
    listTotal: {
      type: Number,
      default: undefined
    },
    pageSize: {
      type: Number,
      default: undefined
    },
    pageIndex: {
      type: Number,
      default: undefined
    },
    init: {
      type: Boolean,
      default: false
    },
    source: {
      type: Array,
      default: () => []
    },
    empty: {
      type: String,
      default: '暂无数据'
    },
    keyword: {
      type: String,
      default: 'ProductName'
    },
    value: {},
    Head: {
      type: Array,
      default: () => {
        return [
          { Value: 'ProductNo', Name: '存货编码', Width: '180' },
          { Value: 'ProductName', Name: '存货名称', Width: '150' },
          { Value: 'ProductSpec', Name: '规格', Width: '150' },
          { Value: 'SkUnitName', Name: '库存默认单位', Width: '150' }
        ]
      }
    }
  },
  data() {
    return {
      // api: require("@/api/ba/account").default,
      api: '',
      // Head: [
      //   { Value: "ProductNo", Name: "存货编码", Width: "180" },
      //   { Value: "ProductName", Name: "存货名称", Width: "150" },
      // ],
      Data: [],
      total: 0,
      value1: '',
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: this.pageIndex
      }
    }
  },
  watch: {
    pageIndex() {
      this.pageParams.pageIndex = this.pageIndex
    },
    value() {
      //
      this.value1 = this.value
      console.log(this.value)
      console.log(this.value1)
      console.log('触发 watch value', this.value1, this.value)
    },
    source() {
      this.Data = this.source
    },
    listTotal() {
      this.total = this.listTotal
    }
  },
  mounted() {
    this.value1 = this.value
    if (this.init) this.initData()
    else this.Data = this.source
    this.total = this.listTotal
  },
  methods: {
    inputText(text) {
      console.log('inputText sub text', text)
      this.$emit('inputText', text)
    },
    changeSelect(val) {
      this.$emit('changeSelect', val)
    },
    currentPage({ val, text1 }) {
      this.$emit('currentPage', { val, text1 })
    },
    initData() {
      console.log('触发 initData')
      this.api.list({ Status: 1 }).then(res => {
        if (res.Code == 0) this.Data = res.Data
      })
    },
    // focus(){
    //   this.$refs.complexSelect.focus();
    // },
    onSelect(data) {
      console.log('data===', data)
      this.$emit('input', data[this.keyword])
      this.$emit('select', data)
    },
    onClear() {
      this.$emit('input', null)
      this.$emit('clear')
    }
  }
}
</script>